import con from '../../../../connection';
import download from './download';
var path = '/operations';
var operations = function (url) { return function () { return ({
    // 操作ログ登録
    post: function (param) { return con.post(url + path, param); },
    download: download("" + url + path),
}); }; };
export default operations;
